import React, { useEffect, useState } from "react";
import { Card, Row, Col, Spinner, Container } from "react-bootstrap";
import { getAuditorDashboardDataApi } from "../../../services/DashboardServices";
import {
  FiPackage,
  FiCheckCircle,
  FiAlertTriangle,
  FiHelpCircle,
  FiLayers,
  FiClock,
} from "react-icons/fi";
import { AiOutlineQrcode } from "react-icons/ai";
import Chart from "react-apexcharts";

const AuditorDashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAuditorDashboardDataApi()
      .then((response) => {
        setDashboardData(response.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <Container
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  if (!dashboardData) {
    return (
      <Container>
        <Card className="mt-3">
          <Card.Body>
            <Card.Text>No data available</Card.Text>
          </Card.Body>
        </Card>
      </Container>
    );
  }

  const firstRowCards = [
    {
      title: "Total Assets",
      value: dashboardData.total_assets,
      icon: <FiPackage size={36} color="#1976d2" />,
    },
    {
      title: "Scanned Assets",
      value: dashboardData.scanned_count,
      icon: <AiOutlineQrcode size={36} color="#2e7d32" />,
    },
    {
      title: "Pending Assets",
      value: dashboardData.pending_count,
      icon: <FiClock size={36} color="#ed6c02" />,
    },
  ];

  const secondRowCards = [
    {
      title: "Verified",
      value: dashboardData.status_breakdown.VERIFIED,
      icon: <FiCheckCircle size={36} color="#2e7d32" />,
    },
    {
      title: "Missing",
      value: dashboardData.status_breakdown.MISSING,
      icon: <FiAlertTriangle size={36} color="#d32f2f" />,
    },
    {
      title: "Misplaced",
      value: dashboardData.status_breakdown.MISPLACED,
      icon: <FiLayers size={36} color="#7b1fa2" />,
    },
    {
      title: "Unassigned",
      value: dashboardData.status_breakdown.UNASSIGNED,
      icon: <FiHelpCircle size={36} color="#616161" />,
    },
  ];

  const pieChartOptions = {
    labels: ["Verified", "Missing", "Misplaced", "Unassigned"],
    colors: ["#2e7d32", "#d32f2f", "#7b1fa2", "#616161"],
    legend: {
      position: "bottom",
    },
    dataLabels: {
      enabled: true,
      formatter: function (val, opts) {
        return opts.w.globals.series[opts.seriesIndex];
      },
    },
  };

  const pieChartSeries = [
    dashboardData.status_breakdown.VERIFIED,
    dashboardData.status_breakdown.MISSING,
    dashboardData.status_breakdown.MISPLACED,
    dashboardData.status_breakdown.UNASSIGNED,
  ];

  return (
    <Container fluid>
      {/* First Row */}
      <div className="mb-2">
        <Row className="g-3">
          {firstRowCards.map((card, index) => (
            <Col key={index} md={4}>
              <Card>
                <Card.Body className="d-flex justify-content-between align-items-center">
                  <div>
                    <Card.Title as="h6">{card.title}</Card.Title>
                    <Card.Text as="h4">{card.value}</Card.Text>
                  </div>
                  {card.icon}
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </div>

      {/* Second Row */}
      <div className="mb-2">
        <Row className="g-3">
          {secondRowCards.map((card, index) => (
            <Col key={index} md={3}>
              <Card>
                <Card.Body className="d-flex justify-content-between align-items-center">
                  <div>
                    <Card.Title as="h6">{card.title}</Card.Title>
                    <Card.Text as="h4">{card.value}</Card.Text>
                  </div>
                  {card.icon}
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </div>

      {/* Third Row (Pie Chart) */}
      <div className="mb-2">
        <Row className="g-3">
          <Col md={6}>
            <Card>
              <Card.Body>
                <Card.Title as="h6">Status Breakdown</Card.Title>
                <Chart
                  options={pieChartOptions}
                  series={pieChartSeries}
                  type="pie"
                  height={300}
                />
              </Card.Body>
            </Card>
          </Col>
          <Col md={6}>{/* You can add another card or leave it empty */}</Col>
        </Row>
      </div>
    </Container>
  );
};

export default AuditorDashboard;
